const AI_API_HOST_STORAGE_KEY = 'aiApiHostUrl';

const DEFAULT_AI_API_BASE = (
  process.env.REACT_APP_EXTERNAL_API_BASE || 'http://localhost:5175'
).replace(/\/+$/, '');

function normalizeAiApiBaseUrl(url) {
  if (!url || typeof url !== 'string') {
    return DEFAULT_AI_API_BASE;
  }

  const trimmed = url.trim();
  if (!trimmed) {
    return DEFAULT_AI_API_BASE;
  }

  return trimmed.replace(/\/+$/, '');
}

export function getDefaultAiApiBaseUrl() {
  return DEFAULT_AI_API_BASE;
}

export function getAiApiBaseUrl() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return DEFAULT_AI_API_BASE;
  }

  const saved = window.localStorage.getItem(AI_API_HOST_STORAGE_KEY);
  return normalizeAiApiBaseUrl(saved);
}

export function setAiApiBaseUrl(url) {
  const normalized = normalizeAiApiBaseUrl(url);

  if (typeof window !== 'undefined' && window.localStorage) {
    if (normalized === DEFAULT_AI_API_BASE) {
      window.localStorage.removeItem(AI_API_HOST_STORAGE_KEY);
    } else {
      window.localStorage.setItem(AI_API_HOST_STORAGE_KEY, normalized);
    }

    window.dispatchEvent(
      new CustomEvent('ai-api-host-changed', {
        detail: {baseUrl: normalized},
      }),
    );
  }

  return normalized;
}
